/**
 * Comment Class
 * @version 3.0.0
 */
function CommentOpen() {
  const comments = document.querySelectorAll('.js-comment');

  comments.forEach((comment) => {

      const textarea = comment.querySelector('textarea');
      const input = comment.querySelector('.comment-input');

      if (!textarea || !input) {
          return;
      }

      textarea.addEventListener("click", (event) => {
          event.preventDefault();

          if (!comment.classList.contains("is-active")) {

              comment.classList.add("is-active");

              if (typeof slideDown === "function") {
                  slideDown(input);
              } else {
                  input.style.display = "flex";
              }

          }
      });
  });
}
document.addEventListener("DOMContentLoaded", CommentOpen);